const middleware = {}

middleware['admin_authenticated'] = require('../middleware/admin_authenticated.ts')
middleware['admin_authenticated'] = middleware['admin_authenticated'].default || middleware['admin_authenticated']

export default middleware
